import apiClient from '../client';

export type StaffRole = 'ADMIN' | 'LOAN_OFFICER' | 'MANAGER' | 'ACCOUNTANT';

export interface StaffUser {
  userId: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  role: StaffRole;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateStaffUserRequest {
  fullName: string;
  email: string;
  phoneNumber: string;
  password: string;
  role: StaffRole;
}

export interface CreateStaffUserResponse {
  success: boolean;
  message: string;
  userId: string;
  user?: StaffUser;
}

export const usersApi = {
  listStaff: async (): Promise<StaffUser[]> => {
    const response = await apiClient.get<{ success: boolean; users: StaffUser[] }>('/admin/users');
    return response.data.users ?? [];
  },

  createStaff: async (data: CreateStaffUserRequest): Promise<CreateStaffUserResponse> => {
    const response = await apiClient.post<CreateStaffUserResponse>('/admin/users', data);
    return response.data;
  },
};
